import { Brain } from 'lucide-react';
import { DivisionPage } from '../components/DivisionPage';
import { CTASection } from '../components/CTASection';

export function AIPage() {
  return (
    <DivisionPage
      accent="accent-ai"
      icon={Brain}
      nameKey="ai.name"
      badgeKey="ai.badge"
      titleKey="ai.heroTitle"
      leadKey="ai.heroLead"
      pitchKey="ai.pitch"
      features={[
        { titleKey: 'ai.s1t', descKey: 'ai.s1d' },
        { titleKey: 'ai.s2t', descKey: 'ai.s2d' },
        { titleKey: 'ai.s3t', descKey: 'ai.s3d' },
        { titleKey: 'ai.s4t', descKey: 'ai.s4d' },
      ]}
      shots={[
        { src: '/mock/ai-agents.svg', captionKey: 'ai.s1t' },
        { src: '/mock/ai-pipeline.svg', captionKey: 'ai.s2t' },
      ]}
    >
      <CTASection />
    </DivisionPage>
  );
}
